//      
                                      
// Using function declaration as arrow function does not play well with the %checks syntax
export default function isMovementAllowed(state       )                  {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/is-movement-allowed.js